import React from 'react';

import { isNumber } from 'lodash';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { IconRestaurent } from 'components/icons/restaurent';
import { useMediaQuery } from 'hooks/use-media-query';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

import { POINTS_TRANSLATION_KEY } from './constants';
import {
  BarLockIcon,
  CrownMeterBar,
  InlineRewardDescription,
  InlineRewardDetail,
  InlineRewardImage,
  InlineRewardImageWrapper,
  InlineRewardName,
  InlineRewardPictureLock,
  InlineRewardWrapper,
  LockOverlay,
  NeededPoints,
  OrderMore,
  OrderMoreToUnlockRewardButton,
  PointsNeededText,
  RewardsPointsDisplay,
} from './incentive-details.styled.default';

interface IInlineRewardDetailsProps {
  pointCost: number | null | undefined;
  remainingPointsNeededForRedemption: number | null | undefined;
  redemptionPercentage: number | null | undefined;
  incentiveDetails: any;
}

export const LockedInlineRewardDetails: React.FC<IInlineRewardDetailsProps> = ({
  pointCost,
  remainingPointsNeededForRedemption,
  redemptionPercentage,
  incentiveDetails,
}) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('headerMobile');
  return (
    <InlineRewardWrapper>
      {!isMobile && (
        <InlineRewardDetail>{formatMessage({ id: 'rewardDetail' })}</InlineRewardDetail>
      )}
      <InlineRewardImageWrapper hasMargin={false}>
        {incentiveDetails.image && (
          <InlineRewardImage
            alt={incentiveDetails.name}
            image={incentiveDetails.image}
            objectFitContain={true}
            quality={100}
          />
        )}

        <LockOverlay />
        <InlineRewardPictureLock fill={primitive.$white} />
      </InlineRewardImageWrapper>
      {/* <InlineRewardDetailWrapper> */}
      {incentiveDetails.name && (
        <InlineRewardName data-testid="reward-name">{incentiveDetails.name}</InlineRewardName>
      )}
      {incentiveDetails.description && (
        <InlineRewardDescription content={incentiveDetails.description} />
      )}
      <OrderMore>
        <RewardsPointsDisplay
          value={formatMessage({ id: 'pointsNumber' }, { points: pointCost })}
          icon={<BarLockIcon fill={Styles.color.primary} />}
        />
        {isNumber(redemptionPercentage) && <CrownMeterBar percentage={redemptionPercentage} />}
        {isNumber(remainingPointsNeededForRedemption) && (
          <PointsNeededText>
            {formatMessage(
              { id: 'yourXPointsAway' },
              {
                points: (
                  <b>
                    <NeededPoints value={remainingPointsNeededForRedemption} icon={null} />
                  </b>
                ),

                pointsSlang: POINTS_TRANSLATION_KEY,
              }
            )}
          </PointsNeededText>
        )}
        <OrderMoreToUnlockRewardButton
          data-testid="order-more-unlock-reward"
          to={routes.menu}
          onClick={() => navigate(routes.menu)}
        >
          <IconRestaurent fill="white" />
          {formatMessage({ id: 'orderMoreToUnlockReward' })}
        </OrderMoreToUnlockRewardButton>
      </OrderMore>
    </InlineRewardWrapper>
  );
};
